<script setup lang="ts">
const props = withDefaults(defineProps<{
  url: string
  title?: string
  inline?: boolean
}>(), {
  title: 'Video',
  inline: true,
})
</script>

<template>
  <VideoPreviewInline v-if="props.inline" :url="props.url" />
  <VideoPreviewModal v-else :url="props.url" :title="props.title">
    <VideoPreviewThumbnail :url="props.url" class="aspect-video group">
      <VideoPreviewPlayIcon />
    </VideoPreviewThumbnail>
  </VideoPreviewModal>
</template>
